import React, {useState} from "react";
import {Form, Modal} from "antd";
import {PlannerTask} from "../../../../../models/planner/planner";
import {useTranslate} from "../../../../../hooks/translate.hook";
import {plannerService} from "../../../../../services/planner/planner.service";
import {UiInputWidgetTags} from "../../../ui/input/widget/tags/ui.input.widget.tags";

interface PlannerTasksTagAddModalProps {
    onClose: () => void;
    task: PlannerTask;
}

export const PlannerTasksTagAddModal: React.FC<PlannerTasksTagAddModalProps> = ({task, onClose}) => {

    const t = useTranslate();
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();

    const initialValues = {
        tags: task.tags.map(t => t.id)
    }

    return (
        <Modal
            visible={true}
            confirmLoading={loading}
            title={t("PLANNER.TASK.FIELDS.TAGS")}
            okText={t("OK")}
            cancelText={t("CANCEL")}
            onOk={() => form.submit()}
            onCancel={onClose}
            maskClosable={false}
        >
            <Form
                form={form}
                layout="vertical"
                name={"planner_task_form"}
                initialValues={initialValues}
                onFinish={() => form
                    .validateFields()
                    .then(async values => {
                        setLoading(true);
                        try {
                            await plannerService.addTag(task.id, values);
                            onClose();
                        } catch (e: any) {
                            form.setFields(e.response?.data?.fields);
                        } finally {
                            setLoading(false);
                        }
                    })
                }
            >
                <Form.Item
                    label={t("PLANNER.TASK.FIELDS.TAGS")}
                    name="tags"
                    rules={[
                        {
                            required: true,
                            message: t(
                                "FROM.ERROR.PLEASE_SELECT_VALUE"
                            ),
                        },
                    ]}
                >
                    <UiInputWidgetTags taskId={task.id} multiple />
                </Form.Item>
            </Form>
        </Modal>
    )
}
